import { useMemo } from 'react';

import { Column } from '../../../../../components/tables/basicTable/BasicTable.types';
import { TEXT_CONTENT } from '../../../../../utils/constants';
import { DATE_FORMAT, toDisplayDate } from '../../../../../utils/date';
import { toFixedDigit } from '../../../../../utils/number';
import PtArrivalsPtsCoveredModel, {
  TPtArrivalsPtsCovered,
} from './PtArrivalsPtsCovered.model';

let columns: Column[] = [
  {
    field: 'category',
    headerName: TEXT_CONTENT.DAY_OF_WEEK,
    sortable: false,
    sx: { minWidth: 150, maxWidth: 150 },
    dataSx: {
      borderRight: '1px solid rgba(0,0,0,0.2)',
    },
  },
];
export default function useWeekWiseSummary(data: TPtArrivalsPtsCovered) {
  const tableData = useMemo(() => {
    let newCols = [...columns];

    if (data) {
      const ScenarioObj = new PtArrivalsPtsCoveredModel(data);

      const { rows, cols } = ScenarioObj.getAllDayWiseSummary();

      let { cols: _cols } = getWeekWiseSummaryColumn(cols || []);

      newCols = [...newCols, ..._cols];

      return {
        rows,
        columns: newCols,
      };
    }
    return {
      rows: [],
      columns: newCols,
    };
  }, [data]);
  return {
    ...tableData,
  };
}
export const getWeekWiseSummaryColumn = (cols: Array<string | number> = []) => {
  const newCols: Column[] = [];
  cols.forEach((d) => {
    const dt = new Date(d);
    newCols.push({
      field: `${dt.valueOf()}`,
      headerName: toDisplayDate(dt.toISOString(), DATE_FORMAT.DAY_ONLY),
      sortable: false,
      renderCell: ({ value, row, colDef }) => {
        return toFixedDigit(value);
      },
    });
  });
  return { cols: newCols };
};
